import React from 'react'
import './ProviderHolds.scss'
import CardIssues from 'src/components/common/CardIssues/CardIssues'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { PURPLE_800 } from '../../../../scss/colorConsts'
import { useDispatch } from 'react-redux'
import { setProviderHoldTabOpened } from '../../../../redux/providerHold/providerHoldSlice'

const ProviderHolds = ({ providerHoldData, issuesCount }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  return (
    <div className="providerholds-container">
      <div className="header-container">
        <span className="providerholds-heading">Provider holds</span>
        <div className="notification-icon-container">
          <i className="fa-solid fa-bell" style={{ color: PURPLE_800, marginRight: '4px' }}></i>
          <div className="notification-number">{issuesCount}</div>
        </div>
      </div>
      <div className="subheading-container pt-2">
        {/*  For spacing */}
        <span className="providerholds-subheading"></span>
        {providerHoldData?.length > 0 && (
          <span
            className="provider-seeall-link"
            onClick={() => {
              dispatch(setProviderHoldTabOpened())
              navigate('/providerhold')
            }}
          >
            See Provider Holds
          </span>
        )}
      </div>
      {providerHoldData?.length > 0 ? (
        providerHoldData.slice(0, 3).map((item, index) => (
          <div key={index}>
            <CardIssues item={item} />
          </div>
        ))
      ) : (
        <div className="noresult-found">
          <p>No result found</p>
        </div>
      )}
    </div>
  )
}

ProviderHolds.propTypes = {
  providerHoldData: PropTypes.any,
  issuesCount: PropTypes.number,
}

export default ProviderHolds
